import {IToken} from "@models/IToken.ts";
import type {IPermissao, PermissaoAplicacao} from "@models/seguranca/permissaoApp.ts";
import dayjs from "dayjs";
import {createContext} from "react";
import {AccountInfo as AccountInfo} from "@azure/msal-browser";
import {IUsuario} from "@models/conta/IUsuario.ts";


export interface AuthContextType {
    conta?: AccountInfo;
    token: IToken;
    userData?: Partial<IUsuario>;
    hasAccess: (permissao: PermissaoAplicacao[] | PermissaoAplicacao) => Access;
    permissoes: IPermissao[],
    refreshData: () => Promise<unknown>
}

export type Access = true | false | 'indirect'

export const AuthContext = createContext<AuthContextType | null>(null);

export const refreshToken = async (instance: any) => {
    const response = await instance.acquireTokenSilent({
        scopes: ["api://cb2ead97-d3cf-41c6-a3cd-34dd615bddf9/User.Read"],
    });

    return {
        token: response.accessToken,
        expira: dayjs(response.expiresOn),
    };
};

